<template>
    <div class="vipt">
        <!-- <div class="screen">
            <el-cascader v-model="value" :options="options" placeholder="审核状态筛选:" @change="handleChange" />
        </div> -->
        <div class="screen">
            <el-cascader v-model="value" :options="optionsw" placeholder="类型筛选:" @change="handleChange" />
        </div>
        <div class="search">
            <div style="width: 24px;height: 24px;">
                <img style="width: 100%;height: 100%;" src="../../assets/secree.png" alt="">
            </div>
            <div>
                <input type="text" placeholder="关键字搜索" v-model="wordKey" @keyup.enter="search">
            </div>
        </div>
        <div class="calendar">
            <el-date-picker class="choosedatas" v-model="choosedata" type="daterange" range-separator="-"
                start-placeholder="" end-placeholder="" @change="changedata" format="MM.DD" :clearable="true" />
        </div>
        <!-- <div class="exdown" @click="productExport" @click="openDialog"> -->
        <!-- <div class="exdown" @click="openDialog">
            <img src="../../assets/goodlist/xdown.png" alt="">&nbsp; 下载
        </div> -->
    </div>
    <div class="vipporpe" v-loading="loading">
        <table>
            <thead>
                <tr>
                    <th style="width: 55px;">

                    </th>
                    <th style="width: 300px;">活动名称

                    </th>
                    <th>
                        活动时间

                    </th>
                    <th>
                        截止时间

                    </th>
                    <!-- <th style="width: 150px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">分类
                        <el-icon>
                            <Sort />
                        </el-icon>
                    </th> -->
                    <th>商品数量 </th>
                    <th>操作 </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in goodslist" :key="index">
                    <td>
                        <el-checkbox v-model="item.chooses" />
                    </td>
                    <td>
                        <div class="stroeh">
                            <!-- <div class="header">
                                <img :src="images(item.ppreviewpic)" alt="">
                            </div> -->
                            <div class="storename">
                                <div class="storepname">{{ item.venueSlogan }}</div>
                                <!-- <div class="stid">ID: {{ item.pid }}</div> -->
                            </div>
                        </div>
                    </td>
                    <td style="color: #111827;">
                        {{ timech(item.beginTime) }}
                    </td>
                    <td>
                        {{ timech(item.finishTime) }}
                    </td>
                    <!-- <td style="">
                        <div class="storepnames" :title="item.className || '未知分类'">
                            {{ item.className || '未知分类' }}

                        </div>
                    </td> -->
                    <td>
                        {{ item.sortNumber }}
                    </td>
                    <td>
                        <div class="caozuo">
                            <!-- <div style="margin-right: 19px;">审核商品</div> -->
                            <div @click="remove(item.uuid)">删除活动</div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div style=" height: 70px;"></div>

    </div>

    <div class="pagechoose">

        显示结果：

        <div class="pagees">

            <input v-model="pageSize" type="number" min="1" max="99" @keyup.enter="pageSizechange">

        </div>

    </div>
    <Noshu :disabled="loading" :lengths="goodslist.length" ></Noshu>

    <div class="example-pagination-block">
        <el-pagination background :disabled="loading" v-model:current-page="pageCount" layout="prev, pager, next"
            :pager-count="5" :page-count="total" @current-change="changepige" />
    </div>
    <yc-mask ref="maskRef" :close-on-click-modal="false">
        <div class="dialog">
            <div class="dialogt">
                <div>
                    导出属性
                </div>
                <div @click="closeDialog">
                    <el-icon>
                        <Close />
                    </el-icon>
                </div>
            </div>
            <div class="exchooses">
                <div class="exchoosee" v-for="(item, index) in exports" :key="index">
                    <div>{{ item.name }}</div>
                    <div>
                        <el-switch v-model="item.chooses" @change="changeex(item.experts, item.chooses)" />
                    </div>
                </div>

            </div>
            <div class="downex">
                <div class="dowm" @click="productExport">
                    下载excel
                </div>
            </div>
        </div>
    </yc-mask>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import seckill from '@/api/seckill'
import store from '@/api/store'
import { ElMessage, ElMessageBox } from 'element-plus'
// import moment from 'moment';
import Noshu from '@/components/Noshu.vue'
import ycMask from '@/components/mask/mask.vue'
import { useRouter } from 'vue-router';
const router = useRouter()
const emit = defineEmits(['totallist'])
//助花商品列表
let goodslist = ref([])
let wordKey = ref('')
let choosekey = ref('')
let pageCount = ref(1)
let total = ref(1)
let exports = ref([])
let chooseex = ref([])
let endTime = ref('')
let startTime = ref('')
let screenType = ref('1')
let loading = ref(false)
// let value = ref('1')
//获取遮罩的实例
let maskRef = ref(null);
//打开弹窗
let openDialog = async () => {
    const res = await seckill.exportFieldScreen(1)
    console.log(res)
    let values = Object.values(res.data);
    for (let a = 0; a < values.length; a++) {
        let parts = values[a].split("_");
        let data = {
            chooses: false,
            name: parts[0],
            experts: parts[1]
        }
        exports._rawValue.push(data)
    }
    console.log(exports)

    maskRef.value.showMask();

};
const remove = (uuid) => {
    ElMessageBox.confirm('是否删除该场次?')
        .then(() => {
            removechang(uuid)
        })
        .catch(() => {
            // catch error
        })
}
const timech = (times) => {
    return times.replace('T', ' ');
}
const removechang = async (uuid) => {
    const res = await seckill.remove(uuid)
    console.log(res)
    if (res.success) {
        ElMessage({
            message: '删除成功',
            type: 'success',
            duration: 1000, // 设置显示时间为2秒
            onClose: function () {
                GoodsList()
            }
        })
    } else {
        ElMessage.error(res.message)
    }
}
const descri = (pid) => {
    router.push({
        path: '/home/goodlist/description',
        query: {
            pid: pid
        }
    })
}
const changeex = (experts, chooses) => {
    console.log(experts, chooses)
    if (chooses) {
        chooseex._rawValue.push(experts)
    } else {
        let index = chooseex._rawValue.indexOf(experts);
        chooseex._rawValue.splice(index, 1)
    }
    console.log(chooseex._rawValue)
}
let pids = ref([])
const choosexid = (pid, choose) => {
    console.log(pid, choose)
    if (choose) {
        pids._rawValue.push(pid)
    } else {
        let index = pids._rawValue.indexOf(pid);
        pids._rawValue.splice(index, 1)
    }
    console.log(pids._rawValue)
}
//关闭弹窗
let closeDialog = () => {
    maskRef.value.closeMask();
};
onMounted(() => {
    GoodsList()
})
let sort = ref(false)
let sortFiled = ref(0)
const state = (states) => {
    pageCount.value = 1

    goodslist.value = []

    if (sortFiled.value != states) {
        sortFiled.value = states
        sort.value = true
    } else {
        sortFiled.value = states
        sort.value = !sort.value
    }
    // sortFiled.value = states
    // sort.value = !sort.value
    GoodsList()
    //    console.log(states)
}
let pageSize = ref(5)

const pageSizechange = () => {
    if (pageSize.value <= 1) {
        pageSize.value = 1
    }
    if (pageSize.value >= 99) {
        pageSize.value = 99
    }
    console.log('pageSize', pageSize.value)
    GoodsList()
}

const GoodsList = async () => {
    loading.value = true

    try {
        let data
        if (startTime.value != '') {

            data = {


                "startDate": startTime.value,
                "endDate": endTime.value,
                "keyword": choosekey.value,
                "keywordType": screenType.value,
                "page": {
                    "current": pageCount.value,
                    "pageSize": pageSize.value
                },
            }
        } else {
            data = {
                "keywordType": screenType.value,
                "keyword": choosekey.value,
                "page": {
                    "current": pageCount.value,
                    "pageSize": pageSize.value
                },
            }
        }
        const res = await store.pageVenue(data)

        if (res.data) {
            console.log(res.data)

            console.log(Math.ceil(res.data.total / pageSize.value))
            emit('totallist', res.data.total)
            total.value = (Math.ceil(res.data.total / pageSize.value))


            goodslist.value = res.data.records
            loading.value = false

        } else {
            goodslist.value = []
            loading.value = false

        }
    } catch (error) {
        console.log(error)
    }
}

const changepige = (val) => {
    console.log(val)
    pageCount.value = val
    GoodsList()
}
const search = () => {
    choosekey.value = wordKey.value
    endTime.value = ''
    startTime.value = ''
    GoodsList()
}
const productExport = async () => {
    let a = pids._rawValue.join(",");
    let b = chooseex._rawValue.join(",");

    let data = {
        productType: 1,
        endTime: endTime.value,
        productListId: a,
        screenListFiled: b,
        startTime: startTime.value,
        wordKey: choosekey.value
    }

    // let data = {
    //     productType: 1,
    //     // endTime: endTime.value, 
    //     productListId: pids._rawValue,
    //     screenListFiled: chooseex._rawValue,
    //     // startTime: startTime.value,
    //     // wordKey: choosekey.value
    // }
    console.log(a, b)

    console.log(data)

    let res = await seckill.productExport(data)
    console.log(res)
    // window.URL.createObjectURL(res)
    let blob = new Blob([res], { type: "application/vnd.ms-excel" });
    let url = window.URL.createObjectURL(blob);
    let link = document.createElement('a');
    link.download = "product.xls";
    link.href = url;
    link.click();

}

const value = ref([])
const options = reactive([
    {
        value: '0',
        label: '全部',
    },
    {
        value: '1',
        label: '产品ID',
    },
    {
        value: '2',
        label: '产品昵称',
    }
])
const optionsw = reactive([
    {
        value: '1',
        label: '秒杀场次名称',
    }
])
const handleChange = (value) => {
    console.log(value)
    screenType.value = value[0]
}
const nowdata = new Date()

const choosedata = ref([nowdata, nowdata])
const changedata = (e) => {
    if (e == null) {
        e = ['', '']
    }
    startTime.value = datahuan(e[0])
    endTime.value = datahuan(e[1])
    pageCount.value = 1
    console.log(startTime.value, endTime.value)
    GoodsList()
}
const datahuan = (days) => {
    if (days) {
        const date = new Date(days)
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const day = date.getDate()
        return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
    } else {
        return ''
    }

}
const productIsSign = async (pid, sign) => {
    console.log(pid, sign)
    let data = {
        productId: pid,
        isSign: sign
    }
    const res = await seckill.productIsSign(data)
    // console.log(res)
    if (res.success) {
        ElMessage({
            message: '修改成功',
            type: 'success',
        })
    } else {
        ElMessage.error('修改失败')
    }
}

</script>

<style lang="scss" scoped>
::v-deep .el-pagination {
    position: absolute;
    bottom: 15px;
    right: 34px;

    .number,
    .btn-quicknext,
    .is-last,
    .is-first {
        background-color: transparent !important;
    }

    .is-active {
        background-color: #EBF3FF !important;
        color: #1787FF !important;
        border-radius: 8px;
    }

}

::v-deep .choosedatas {
    width: 100%;
    height: 100%;
    background-color: #FAFAFA;
    --el-input-border-color: transparent;
    cursor: pointer;


    input {
        font-size: 16px;
        color: #718096;
        cursor: pointer;
    }

}

::v-deep .el-input {
    width: 168px;
    height: 48px;
    font-size: 16px;
    --el-input-text-color: #718096;
    --el-input-border-color: transparent;

    .el-input__wrapper {
        background: #FAFAFA !important;

        .el-icon {
            width: 26px;
            height: 26px;

            svg {
                width: 26px;
                height: 26px;
            }
        }
    }

    ::placeholder {
        font-weight: 400;
        font-size: 14px;
        color: #718096;
    }
}

::v-deep .el-checkbox__input {
    height: 20px;

    .el-checkbox__inner {
        width: 20px;
        height: 20px;
        border-radius: 10px;
    }

    .el-checkbox__inner {
        &::after {
            top: 4px;
            left: 8px;
        }

    }
}

.pagechoose {
    position: absolute;
    bottom: 0px;
    left: 14px;
    width: 100%;
    height: 70px;
    padding-left: 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .pagees {
        width: 71px;
        height: 40px;
        border: 1px solid #EEEFF2;
        border-radius: 8px;
        padding: 8px 0 0 0px;
        box-sizing: border-box;

        input {
            width: 80%;


        }
    }
}


.vipt {
    padding-top: 9px;
    margin-left: 15px;
    display: flex;

    .screen {
        width: 168px;
        height: 48px;
        background: #F8F8F8;
        border-radius: 8px;
        margin-right: 24px;
    }

    .search {
        width: 412px;
        height: 48px;
        margin-right: 24px;
        background: #FAFAFA;
        box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
        border-radius: 8px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-left: 20px;

        input {
            width: 300px;
            border: none;
            outline: none;
            font-size: 16px;
            background: #FAFAFA;

        }

        ::placeholder {
            font-weight: 400;
            font-size: 14px;
            color: #7D8592;
        }
    }

    .calendar {
        width: 168px;
        height: 48px;
        background: #FAFAFA;
        border-radius: 8px;
    }

    .exdown {
        width: 101px;
        height: 48px;
        background: #FAFAFA;
        border-radius: 8px;
        margin-left: 31px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        font-size: 14px;
        color: #718096;
        cursor: pointer;


        img {
            width: 17px;
            height: 21px;
        }
    }

}

.vipporpe {
    width: 100%;
    // padding-left: 15px;
    box-sizing: border-box;


    table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        thead {
            text-align: left;
            font-size: 14px;
            font-weight: 400;
            color: #4D585F;
            border-bottom: 1px solid #EEEFF2;
            height: 46px;

            th {
                vertical-align: middle;
            }

            th:first-child {
                padding-left: 15px;

            }

            .states {
                text-align: center;
            }
        }

        tbody {
            tr {
                height: 96px;
                font-size: 14px;
                font-weight: 400;
                color: #000000;
                border-bottom: 1px solid #EEEFF2;


                td:first-child {
                    padding-left: 15px;

                }

                td:nth-child(2) {
                    width: 350px;

                    .stroeh {
                        display: flex;

                        .header {
                            width: 56px;
                            height: 56px;
                            background-color: #718096;
                            border-radius: 8px;
                            margin-right: 24px;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }

                        .storename {
                            width: 200px;
                            font-size: 16px;

                            font-weight: 400;
                            color: #111827;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-around;

                            .storepname {
                                overflow: hidden;
                                /* 隐藏溢出的文本 */
                                text-overflow: ellipsis;
                                /* 添加省略号 */
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                /* 设置要截断的行数 */
                                -webkit-box-orient: vertical;
                            }

                            .stid {
                                font-size: 14px;
                                font-family: HelveticaNeue;
                                color: #718096;
                            }
                        }

                    }
                }

                td:last-child {

                    color: #1787FF;

                }

                td {

                    vertical-align: middle;

                    .storepnames {
                        overflow: hidden;
                        /* 隐藏溢出的文本 */
                        text-overflow: ellipsis;
                        /* 添加省略号 */
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                        /* 设置要截断的行数 */
                        -webkit-box-orient: vertical;
                    }

                    .caozuo {
                        display: flex;
                        cursor: pointer;
                    }

                    .statea {
                        width: 66px;
                        height: 42px;
                        background: #EBF3FF;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 14px;
                        font-weight: 400;
                        color: #1787FF;
                    }


                }


            }

            tr:hover {
                background-color: #f3f3f3;

            }
        }

    }
}

.dialog {
    position: relative;
    width: 500px;
    height: 608px;
    background: #FFFFFF;
    border-radius: 8px;
    overflow: hidden;

    .dialogt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.88);
        margin-bottom: 20px;
        padding: 23px 36px 0 35px;
    }

    .exchooses {
        padding: 23px 36px 0 35px;
        height: 400px;
        overflow: auto;

        .exchoosee {
            display: flex;
            height: 38px;
            justify-content: space-between;
            font-size: 14px;
            font-weight: 400;
            color: #111827;
            align-items: center;
            margin-top: 13px;
        }
    }

    .downex {
        .dowm {
            width: 121px;
            height: 51px;
            background: #3686FF;
            border-radius: 8px;
            text-align: center;
            line-height: 51px;
            font-size: 17px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
        }

        display: flex;
        align-items: center;
        justify-content: center;
        width: 500px;
        height: 120px;
        background: #F2F8FC;

    }

}
</style>